/* Glambe scroll bridge.
   Horizon scrolls inside .page-wrapper on screens 990px and wider (so its side drawer can push the page),
   and scrolls the normal page below that. Glambe scroll animations (GSAP ScrollTrigger, progress line,
   parallax, sticky button) were written for the normal page scroll. This small file points them at whichever
   one is really scrolling. It does nothing on phones and tablets. */
(function () {
  if (window.__gbScroll) return;
  window.__gbScroll = 1;
  var mq = window.matchMedia ? window.matchMedia('(min-width: 990px)') : { matches: false };
  function pw() { return document.querySelector('.page-wrapper'); }
  function active() {
    var w = pw();
    return !!(w && mq.matches && window.getComputedStyle(w).overflowY !== 'visible');
  }
  window.__gbScroller = function () { return active() ? pw() : window; };
  window.__gbMax = function () {
    var w = pw();
    return active() ? Math.max(0, w.scrollHeight - w.clientHeight) : Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  };

  /* page position reads */
  ['scrollY', 'pageYOffset'].forEach(function (n) {
    var d = Object.getOwnPropertyDescriptor(window, n);
    try {
      Object.defineProperty(window, n, {
        configurable: true,
        get: function () { return active() ? pw().scrollTop : (d && d.get ? d.get.call(window) : 0); }
      });
    } catch (e) { /* leave as is */ }
  });

  /* page position writes */
  var oTo = window.scrollTo.bind(window), oBy = window.scrollBy.bind(window);
  function opts(a, b) {
    var o = (a && typeof a === 'object') ? a : { left: a, top: b }, p = {};
    if (o.top != null) p.top = o.top;
    if (o.left != null) p.left = o.left;
    if (o.behavior) p.behavior = o.behavior;
    return p;
  }
  window.scrollTo = window.scroll = function (a, b) {
    if (active()) pw().scrollTo(opts(a, b)); else oTo.apply(window, arguments);
  };
  window.scrollBy = function (a, b) {
    if (active()) pw().scrollBy(opts(a, b)); else oBy.apply(window, arguments);
  };

  /* tell page-level scroll listeners when the container scrolls */
  function forward() {
    var w = pw();
    if (!w || w.__gbFwd) return;
    w.__gbFwd = 1;
    w.addEventListener('scroll', function () { if (active()) window.dispatchEvent(new Event('scroll')); }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', forward); else forward();

  /* GSAP ScrollTrigger: use the real scroller */
  var st;
  try {
    Object.defineProperty(window, 'ScrollTrigger', {
      configurable: true,
      get: function () { return st; },
      set: function (v) {
        st = v;
        try { if (v && v.defaults && active()) v.defaults({ scroller: '.page-wrapper' }); } catch (e) { /* ignore */ }
      }
    });
  } catch (e) { /* ignore */ }

  /* crossing 990px swaps the scroller, so start again cleanly (only on pages that use ScrollTrigger) */
  var last = mq.matches;
  function onChange() {
    if (mq.matches === last) return;
    last = mq.matches;
    if (window.ScrollTrigger && !(window.Shopify && window.Shopify.designMode)) window.location.reload();
  }
  if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
})();
